import { combineReducers } from '@reduxjs/toolkit';
import { reducer as walletReducer } from '../slices/wallet';

const rootReducer = combineReducers({

  wallet: walletReducer,

});

export default rootReducer;